<template>
  <div>
    <mdb-form-inline class="active-cyan active-cyan-2">
      <mdb-btn color="indigo" @click="startFindingSurrogateIdDataWithCode">{{
        $t("find_surrogate_id")
      }}</mdb-btn>
    </mdb-form-inline>
    <InputModal
      :characterMinLimit=2
      :modalShow="surrogateSearchModal"
      :dataShow="dataLoadReady"
      :title="$t('find_surrogate_id_modal_title')"
      :description="$t('find_surrogate_id_modal_description')"
      :inputLabel="$t('find_surrogate_id_modal_inputlabel')"
      :buttontext="$t('find_surrogate_id_modal_button')"
      :buttonDeleteText="$t('clean_surrogate_id_modal_button')"
      :dataModal="dataModal"
      v-on:modal-cancelled="SurrogateIdSearchCancelled"
      v-on:modal-ok="SurrogateIdSearch"
      v-on:modal-delete="cleanSurrogateIdDataWithCode"

    />
  </div>
</template>

<script>
import { mdbBtn, mdbFormInline } from "mdbvue";
import InputModal from "./InputModal.vue";
export default {
  name: "FindSurrogateId",
  components: {
    mdbBtn,
    mdbFormInline,
    InputModal
  },
  data() {
    return {
      filterText: "",
      surrogateSearchModal: false,
      dataLoadReady: false,
      dataModal: {
        columns: [
          {
            label: "Id",
            field: "id"
          },
          {
            label: "Jäsennumero",
            field: "surrogate"
          },
          {
            label: "Nimi",
            field: "name"
          },
          {
            label: "Voimassa",
            field: "lastuntil"
          },
          {
            label: "Luotu",
            field: "created"
          },
          {
            label: "Päivitetty",
            field: "updated"
          },
          {
            label: "Aktiivinen",
            field: "active"
          },
          {
            label: "asiakasnumero",
            field: "customer_id"
          }
        ],
        rows: null
      },
      retrievebypath: "/1.0/front/surrogate/",
      cleanpath: "/1.0/front/surrogate"
    };
  },
  methods: {
    SurrogateIdSearchCancelled() {
      this.surrogateSearchModal = false;
    },
    SurrogateIdSearch(val) {
      this.dataLoadReady = false;
      this.findSurrogateIdDataWithCode(val);
    },
    startFindingSurrogateIdDataWithCode() {
      this.surrogateSearchModal = true;
    },
    cleanSurrogateIdDataWithCode(val) {
      this.$http
        .post(
          this.cleanpath, { surrogate: val })
        .then(response => {
          if (response.status == 200) {
            this.dataLoadReady = false;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch(error => {
          return error;
        });
    },
    findSurrogateIdDataWithCode(val) {
      this.$http
        .get(
          this.retrievebypath + val)
        .then(response => {
          if (response.status == 200) {
            this.dataModal.rows = response.data.surrogates;
            this.dataLoadReady = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch(error => {
          return error;
        });
    }
  }
};
</script>

<style scoped>
.active-cyan input[type="text"] {
  border: 1px solid indigo;
  box-shadow: 0 1px 0 0 indigo;
}
</style>
